module.exports = "/_next/static/images/098ff23b716d8b12bc00dbc994f0f123-hero.svg";